import {
  POST_BIRTH_DETAILS_INPUT,
  POST_BIRTH_DETAILS_INPUT_SUCCESS,
  POST_BIRTH_DETAILS_INPUT_FAIL,
  GET_BIRTH_CHART_LIST,
  GET_BIRTH_CHART_LIST_SUCCESS,
  GET_BIRTH_CHART_LIST_FAIL,
  GET_BIRTH_CHART,
  GET_BIRTH_CHART_SUCCESS,
  GET_BIRTH_CHART_FAIL,
  GET_PLACES,
  SET_PLACE_KEYWORD,
  CLEAR_PLACE_KEYWORD,
  CLEAR_PLACES,
  GET_BIRTH_CHART_PDF,
  GET_BIRTH_CHART_PDF_FAIL,
  GET_BIRTH_CHART_PDF_SUCCESS,
  GET_PLACES_API_TOKEN,
  GET_PLACES_API_TOKEN_SUCCESS,
  GET_PLACES_API_TOKEN_FAIL,
  CREATE_PAYPAL_ORDER,
  CREATE_PAYPAL_ORDER_SUCCESS,
  CREATE_PAYPAL_ORDER_FAIL,
  APPROVE_PAYPAL_ORDER,
  APPROVE_PAYPAL_ORDER_SUCCESS,
  APPROVE_PAYPAL_ORDER_FAIL,
  REPORT_ORDER_CONFIRMATION,
  REPORT_ORDER_CONFIRMATION_SUCCESS,
  REPORT_ORDER_CONFIRMATION_FAIL,
} from "./actionTypes"

export const postBirthDetailsInput = (birthDetail) => ({
  type: POST_BIRTH_DETAILS_INPUT,
  birthDetail,
})

export const postBirthDetailsInputSuccess = birthDetail => ({
  type: POST_BIRTH_DETAILS_INPUT_SUCCESS,
  payload: birthDetail,
})

export const postBirthDetailsInputFail = error => ({
  type: POST_BIRTH_DETAILS_INPUT_FAIL,
  payload: error,
})

export const getBirthChartList = (page, size, sortOrder, reportCreatedDate) => ({
  type: GET_BIRTH_CHART_LIST,
  payload: { page, size, sortOrder, reportCreatedDate }
})

export const getBirthChartListSuccess = birthChartListPage => ({
  type: GET_BIRTH_CHART_LIST_SUCCESS,
  payload: birthChartListPage,
})

export const getBirthChartListFail = error => ({
  type: GET_BIRTH_CHART_LIST_FAIL,
  payload: error,
})

export const getBirthChart = chartId => ({
  type: GET_BIRTH_CHART,
  chartId,
})

export const getBirthChartSuccess = birthChart => ({
  type: GET_BIRTH_CHART_SUCCESS,
  payload: birthChart,
})

export const getBirthChartFail = error => ({
  type: GET_BIRTH_CHART_FAIL,
  payload: error,
})

export const getPlaces = placeInput => ({
  type: GET_PLACES,
  placeInput,
})

export const getPlacesSuccess = places => ({
  type: GET_PLACES,
  payload: places,
})

export const getPlacesFail = error => ({
  type: GET_PLACES,
  payload: error,
})

export const clearPlaces = () => ({
  type: CLEAR_PLACES,
})

export const setPlaceKeyword = placeKeyword => ({
  type: SET_PLACE_KEYWORD,
  placeKeyword,
})

export const clearPlaceKeyword = () => ({
  type: CLEAR_PLACE_KEYWORD,
})

export const getBirthChartPDF = birthChartId => ({
  type: GET_BIRTH_CHART_PDF,
  birthChartId,
})

export const getBirthChartPDFSuccess = birthChartPDFStatus => ({
  type: GET_BIRTH_CHART_PDF_SUCCESS,
  payload: birthChartPDFStatus,
})

export const getBirthChartPDFFail = error => ({
  type: GET_BIRTH_CHART_PDF_FAIL,
  payload: error,
})

export const getPlacesAPIToken = () => ({
  type: GET_PLACES_API_TOKEN
})

export const getPlacesAPITokenSuccess = placesAPIToken => ({
  type: GET_PLACES_API_TOKEN_SUCCESS,
  payload: placesAPIToken,
})

export const getPlacesAPITokenFail = error => ({
  type: GET_PLACES_API_TOKEN_FAIL,
  payload: error,
})

export const createPayPalOrder = () => ({
  type: CREATE_PAYPAL_ORDER,
  })

export const createPayPalOrderSuccess = createPayPalOrder => ({
  type: CREATE_PAYPAL_ORDER_SUCCESS,
  payload: createPayPalOrder,
})

export const createPayPalOrderFail = error => ({
  type: CREATE_PAYPAL_ORDER_FAIL,
  payload: error,
})

export const approvePayPalOrder = (orderId, reportID) => ({
  type: APPROVE_PAYPAL_ORDER,
  orderId,
  reportID,
  })

export const approvePayPalOrderSuccess = approvePayPalOrder => ({
  type: APPROVE_PAYPAL_ORDER_SUCCESS,
  payload: approvePayPalOrder,
})

export const approvePayPalOrderFail = error => ({
  type: APPROVE_PAYPAL_ORDER_FAIL,
  payload: error,
})

export const reportOrderConfirm = ( reportID) => ({
  type: REPORT_ORDER_CONFIRMATION,
   reportID,
  })

export const reportOrderConfirmSuccess = approvePayPalOrder => ({
  type: REPORT_ORDER_CONFIRMATION_SUCCESS,
  payload: approvePayPalOrder,
})

export const reportOrderConfirmFail = error => ({
  type: REPORT_ORDER_CONFIRMATION_FAIL,
  payload: error,
})